<template>
    <div class="root">
        EMONEY HOME!
    </div>
</template>

<script>

export default {
    name: 'home',
    components: {
    },
    data() {
        return {

        }
    }
}
</script>
<style lang="scss" scoped>

.root{
    font-size:16px;
}
</style>



// WEBPACK FOOTER //
// Home.vue?5e740dfa